module.exports = __webpack_public_path__ + "img/subsidy.2f2929f6.png";